import { gql } from '@generated/gql';

const selectIpQuoteMutation = gql(`
  mutation SelectIpQuote($input: SelectQuoteInput!) {
    selectQuote(input: $input) {
      id
      monthlyCost {
        value
      }
      quotes {
        id
        totalMonthlyCost {
          value
        }
        selected
        product {
          id
          name
          type
          subtype
        }
      }
    }
  }
`);

const deselectIpQuoteMutation = gql(`
  mutation DeselectIpMutation($input: DeselectQuoteInput!) {
    deselectQuote(input: $input) {
      id
    }
  }
`);

export { selectIpQuoteMutation, deselectIpQuoteMutation };
